"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FileChooser;
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _utils = require("../../utils");
var _Button = _interopRequireDefault(require("../Button/Button"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
const useStyles = (0, _styles.makeStyles)(theme => ({
  hiddenInput: {
    display: 'none'
  },
  icon: {
    height: '120px',
    width: '120px'
  },
  button: {
    marginTop: theme.spacing(3)
  },
  link: {
    color: theme.palette.TwClrTxtBrand,
    fontFamily: 'Inter',
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '16px',
    marginTop: theme.spacing(2),
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
}));
function FileChooser(props) {
  const {
    acceptFileType,
    chooseFileText,
    files,
    fileSelectedText,
    iconName,
    maxFiles,
    multipleSelection,
    onChoosingFiles,
    replaceFileText,
    selectedFile,
    setFiles,
    template,
    uploadDescription,
    uploadMobileDescription,
    uploadText
  } = props;
  const {
    isMobile
  } = (0, _utils.useDeviceInfo)();
  const classes = useStyles();
  const inputRef = (0, _react.useRef)(null);
  const theme = (0, _material.useTheme)();
  const [editing, setEditing] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    setEditing(!!selectedFile);
  }, [selectedFile]);
  const addFiles = fileList => {
    const newFiles = [];
    for (let i = 0; i < fileList.length; i++) {
      const fileItem = fileList.item(i);
      if (fileItem) {
        newFiles.push(fileItem);
      }
    }
    if (newFiles.length) {
      setFiles([...(files !== null && files !== void 0 ? files : []), ...newFiles].slice(0, maxFiles));
    }
  };
  const dropHandler = event => {
    event.preventDefault();
    addFiles(event.dataTransfer.files);
  };
  const enableDropping = event => {
    event.preventDefault();
  };
  const onChooseFileHandler = () => {
    var _inputRef$current;
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.click();
    onChoosingFiles === null || onChoosingFiles === void 0 ? void 0 : onChoosingFiles();
  };
  const onFileChosen = event => {
    if (editing) {
      setEditing(false);
    }
    if (event.currentTarget.files) {
      addFiles(event.currentTarget.files);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    onDrop: dropHandler,
    onDragOver: enableDropping,
    border: "1px dashed ".concat(theme.palette.TwClrBrdrTertiary),
    borderRadius: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: theme.spacing(3),
    sx: {
      background: theme.palette.TwClrBg
    }
  }, iconName && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: iconName,
    className: classes.icon,
    size: "xlarge"
  }), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    color: theme.palette.TwClrTxt,
    fontSize: 14,
    fontWeight: 600,
    margin: theme.spacing(0, 0, 1)
  }, !editing && ((files || []).length > 0 && !multipleSelection ? files === null || files === void 0 ? void 0 : files[0].name : uploadText)), /*#__PURE__*/_react.default.createElement(_material.Typography, {
    color: theme.palette.TwClrTxt,
    fontSize: 12,
    fontWeight: 400,
    margin: 0
  }, (editing || (files || []).length > 0) && !multipleSelection ? fileSelectedText : isMobile && uploadMobileDescription ? uploadMobileDescription : uploadDescription), /*#__PURE__*/_react.default.createElement("input", {
    type: "file",
    ref: inputRef,
    className: classes.hiddenInput,
    onChange: onFileChosen,
    accept: acceptFileType,
    multiple: multipleSelection || false,
    value: ''
  }), /*#__PURE__*/_react.default.createElement(_Button.default, {
    onClick: onChooseFileHandler,
    disabled: maxFiles !== undefined ? (files || []).length >= maxFiles : false,
    label: !multipleSelection && ((files || []).length === 1 || editing) ? replaceFileText : chooseFileText,
    priority: "secondary",
    type: "passive",
    className: classes.button
  }), template && /*#__PURE__*/_react.default.createElement(_material.Link, {
    href: template.url,
    target: "_blank",
    className: classes.link
  }, template.text));
}